<template>
  <Landing/>
</template>

<script>
import Landing from './components/LandingPage.vue'

export default {
  name: 'App',
  components: {
    Landing
  }
}
</script>

